import { ChevronRight, Home } from 'lucide-react'
import { Link } from 'react-router-dom'

export interface BreadcrumbItem {
  label: string
  href?: string
}

interface BreadcrumbProps {
  items: BreadcrumbItem[]
  className?: string
}

export function Breadcrumb({ items, className = '' }: BreadcrumbProps) {
  return (
    <nav aria-label="Breadcrumb" className={`flex items-center gap-1.5 text-sm ${className}`}>
      <Link to="/" className="text-warm-400 hover:text-copper-500 transition-colors">
        <Home className="w-4 h-4" />
      </Link>
      {items.map((item, i) => (
        <span key={i} className="flex items-center gap-1.5">
          <ChevronRight className="w-3.5 h-3.5 text-warm-300" />
          {item.href && i < items.length - 1 ? (
            <Link to={item.href} className="text-warm-500 hover:text-copper-500 transition-colors">
              {item.label}
            </Link>
          ) : (
            <span className="text-midnight-800 font-medium">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  )
}
